import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Button, Form, Modal} from 'react-bootstrap';
import ApiService from '../../api/ApiService';
import LocalDataService from '../../api/LocalDataService';
import './userProfile.css'
import QRCode from 'qrcode';
import {toast} from 'react-toastify';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClose} from "@fortawesome/free-solid-svg-icons";

const UserProfile = forwardRef((props, ref) => {
    const [user, setUser] = useState(null);
    const [showLoginModal, setshowLoginModal] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('')
    const api = new ApiService();
    //发送验证码状态
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [countdown, setCountdown] = useState(60);
    const timerId = useRef(null);
    const clearTimerId = useRef(null);
    const phoneInputRef = useRef(null); // 新增ref用于直接访问手机号输入框
    const [qrCodeUrl, setQrCodeUrl] = useState(null);
    const [playTypeIndex, setPlayTypeIndex] = useState(0);
    const captchaButtonRef = useRef(null); // 创建一个ref来引用验证码按钮

    const [isBindingMobileStatus, setIsBindingMobileStatus] = useState(false);//是否在绑定手机页面
    // 开始倒计时
    const startCountdown = () => {
        setIsButtonDisabled(true);
        setCountdown(60);

        // 开始倒计时
        const interval = setInterval(() => {
            setCountdown(prevCountdown => {
                if (prevCountdown === 1) {
                    clearInterval(interval);
                    setIsButtonDisabled(false);
                    return 0;
                } else {
                    return prevCountdown - 1;
                }
            });
        }, 1000);
    };

    // 处理验证码按钮点击事件
    const handleVerificationClick = async () => {
        const phoneNumber = phoneInputRef.current?.value || '';

        if (phoneNumber == '') {
            toast.error('请输入手机号')
            return
        }

        // 移动端直接发送验证码，无需阿里云验证码
        let res = await api.get_message_code(phoneNumber)
        if (res.code != 200) {
            toast.error(JSON.stringify(res))
            return
        }
        startCountdown();
    };


    const handlePhoneNumberChange = (e) => {
        setPhoneNumber(e.target.value);
    };


    // 登录处理
    const handleLogin = async (event) => {

        event.preventDefault();
        const formData = new FormData(event.target);
        const phoneNumber = formData.get('phoneNumber');
        const password = formData.get('password');
        const phoneCode = formData.get('verificationCode');

        try {
            let user = null;
            var loginInfo = await api.login_message(phoneNumber, 6, phoneCode);
            if (loginInfo.code != 200) {
                toast.error(loginInfo.msg);
                return;
            }
            LocalDataService.set_login_data(loginInfo.data.user.accessToken);
            await api.saveUserSuperiorInviteCode(LocalDataService.loadInviteCode());
            user = await api.get_user_info();
            await loadApiKeyList();
            setshowLoginModal(false);
            setUser(user);
            LocalDataService.set_user_data(user.data);
            // 触发用户状态更新事件
            window.dispatchEvent(new Event('userLoginStatusChanged'));
        } catch (error) {
            toast.error(`登录失败: ${error.data}`);
        }
    };

    // 绑定处理
    const handleBindingMobile = async (event) => {

        event.preventDefault();
        const formData = new FormData(event.target);
        const phoneNumber = formData.get('phoneNumber');
        const phoneCode = formData.get('verificationCode');

        try {
            var loginInfo = await api.binding_mobile(phoneNumber, phoneCode);
            if (loginInfo.code != 200) {
                toast.error(loginInfo.msg);
                return;
            }
            toast('绑定成功');
            setshowLoginModal(false);
        } catch (error) {
            toast.error(`绑定失败: ${error.data}`);
        }
    };
    const loadApiKeyList = async () => {
        var getList = await api.get_api_token_list();
        if (getList.code === 200) {
            if (getList.data.length > 0) {
                LocalDataService.setApiToken(getList.data[0].token);
            } else {
                var createToken = await api.create_api_token();
                if (createToken.code === 200) {
                    var newList = await api.get_api_token_list()
                    LocalDataService.setApiToken(newList.data[0].token);
                }
            }
        }
    };
    //供父组件调用
    useImperativeHandle(ref, () => ({
        showLoginModal: (showBind) => {
            setshowLoginModal(true);
            setIsBindingMobileStatus(showBind)
        },
        // 你可以在这里添加更多子组件的方法
    }));

    useEffect(() => {
        let user_info = LocalDataService.load_user_data();
        setUser(user_info);
        get_qrcode()

        return () => {
            // 清除定时器
            if (timerId.current) {
                clearInterval(timerId.current);
            }
            if (clearTimerId.current) {
                clearTimeout(clearTimerId.current);
            }
        };
    }, [showLoginModal, captchaButtonRef.current]);


    // useImperativeHandle(ref, () => ({
    //   showModal: () => {
    //     setIsVisible(true);
    //     get_qrcode()
    //   },
    // }));

    const get_qrcode = async () => {
        console.log('登录定时器');

        const api = new ApiService();

        // 清除定时器
        if (timerId.current) {
            clearInterval(timerId.current);
        }
        if (clearTimerId.current) {
            clearTimeout(clearTimerId.current);
        }
        // 检查弹框是否可见
        if (!showLoginModal || isBindingMobileStatus) {
            return;
        }

        let res = await api.get_qrcode()
        if (res.data.url) {
            // 使用 qrcode 库生成二维码数据
            QRCode.toDataURL(res.data.url, (err, url) => {
                if (err) {
                    console.error(err);
                    return;
                }
                setQrCodeUrl(url);
                timerId.current = setInterval(() => {
                    get_order_info(res.data.sceneId);
                }, 1000);
                clearTimerId.current = setTimeout(() => {
                    clearInterval(timerId.current);
                }, 5 * 60 * 1000);
            });
        }


    }

    const get_order_info = async (scene_id) => {
        let api = new ApiService();
        let res = await api.check_qrcode_status(scene_id);

        if (!res) {
            toast.error('扫码失败，请重新扫码')
            clearInterval(timerId.current);
            return
        }
        if (res.data.scan === true && !res.data.accessToken.isEmpty) {
            LocalDataService.set_login_data(res.data.accessToken);
            await api.saveUserSuperiorInviteCode(LocalDataService.loadInviteCode());
            let user = await api.get_user_info();
            setUser(user);
            await loadApiKeyList();
            LocalDataService.set_user_data(user.data);
            toast('登录成功')
            // 触发用户状态更新事件
            window.dispatchEvent(new Event('userLoginStatusChanged'));
            if (!user.data.user.isBindingMobile) {//未绑定手机号
                setIsBindingMobileStatus(true);
            } else {//已经绑定手机号了的
                setshowLoginModal(false);
            }
        }

    }


    // 登录弹窗控制
    const handleShowLoginModal = () => {
        setshowLoginModal(true);
    };

    const handleCloseLoginModal = () => {
        setIsBindingMobileStatus(false);
        setshowLoginModal(false);
    };


    // 登出处理
    const handleLogout = () => {
        setUser(null);
        LocalDataService.set_user_data(null);
        LocalDataService.set_login_data(null);
    };


    const phoneIcon = '/images/login/login_phone.svg';
    const codeIcon = '/images/login/login_code.svg';
    const wechatIcon = '/images/login/login_wechat_icon.svg';
    return (
        <>

            <div id="captcha-element" style={{display: isButtonDisabled ? 'none' : 'initial'}}></div>
            {/* 登录弹窗 */}
            <Modal show={showLoginModal} centered fullscreen={false}>

                <Modal.Header style={{
                    justifyContent: 'center',
                    background: '#1F222A',
                    borderBottomColor: '#494c57',
                    borderBottomWidth: '1px'
                }}>
                    <Modal.Title
                        style={{color: 'white'}}>{isBindingMobileStatus ? "绑定手机号" : "HELLO，欢迎登陆"}</Modal.Title>
                    <FontAwesomeIcon icon={faClose} color={'#B3BFC4'} onClick={handleCloseLoginModal}
                                     style={{position: 'absolute', right: '0px', top: '0px', padding: '16px'}}/>
                </Modal.Header>
                <Modal.Body style={{background: '#1F222A'}}>
                    {isBindingMobileStatus ?
                        <Form onSubmit={handleBindingMobile}>
                            <h6 style={{
                                color: '#B3BFC4',
                                textAlign: 'center',
                            }}>绑定后，您可使用此手机号登录我们的APP和网站。隐私受严格保护</h6>
                            <Form.Group className={'mb-3 d-flex'}
                                        style={{background: '#2A2E39', padding: '4px 16px', borderRadius: '12px'}}>
                                    <span className={'align-content-center'} style={{marginRight: '10px'}}>
                                        <img src={phoneIcon} width={'20px'} alt={''}/>
                                    </span>

                                <Form.Control ref={phoneInputRef}
                                              style={{background: 'transparent', border: 'none', color: 'white'}}
                                              type="text"
                                              name="phoneNumber" placeholder={'请输入手机号'} required
                                              onChange={handlePhoneNumberChange}/>
                            </Form.Group>


                            <Form.Group className={'mb-3 d-flex'}
                                        style={{
                                            background: '#2A2E39',
                                            padding: '4px 0px 4px 16px',
                                            borderRadius: '12px'
                                        }}>
                                    <span className={'align-content-center'} style={{marginRight: '10px'}}>
                                        <img src={codeIcon} width={'20px'} alt={''}/>
                                    </span>
                                <Form.Control style={{background: 'transparent', border: 'none', color: 'white'}}
                                              type="text"
                                              name="verificationCode" required placeholder={'请输入验证码'}/>

                                <button
                                    type={'button'}
                                    style={{
                                        width: '120px',
                                        color: '#02C8E3',
                                        border: 'none',
                                        background: 'none',
                                        flexShrink: 0,
                                        textAlign: 'center',
                                        alignContent: 'center'
                                    }}
                                    disabled={isButtonDisabled}
                                    onClick={handleVerificationClick}>
                                    {isButtonDisabled ? `等待${countdown}秒` : '获取验证码'}
                                </button>

                            </Form.Group>


                            <div className='login-bottom mb-2 mt-2 d-flex justify-content-around'>
                                <Button variant="primary" type="button" onClick={handleCloseLoginModal} style={{
                                    width: '46%',
                                    background: 'none',
                                    color: '#02C8E3',
                                    border: '#02C8E3 solid 2px',
                                    height: '42px',
                                }}>
                                    暂不绑定
                                </Button>
                                <Button variant="primary" type="submit" style={{
                                    width: '46%',
                                    background: 'linear-gradient(90deg, #963BC8, #02C8E3)',
                                    border: 'none',
                                    height: '42px',
                                }}>
                                    保存手机号
                                </Button>
                            </div>
                        </Form>
                        :
                        <>
                            <div className='login-type'>

                                <div className='custom-play-type-content '>
                                    <div
                                        className={`custom-play-type-info ${playTypeIndex == 1 ? 'custom-play-type-info-active' : ''}`}
                                        onClick={() => setPlayTypeIndex(1)}>
                                        手机号登录
                                    </div>

                                    <div
                                        className={`custom-play-type-info ${playTypeIndex == 0 ? 'custom-play-type-info-active' : ''}`}
                                        onClick={() => setPlayTypeIndex(0)}>
                                        扫码登录
                                    </div>
                                </div>
                            </div>
                            {
                                playTypeIndex == 0 ?
                                    <div className='weixin-code'>
                                        {qrCodeUrl && (
                                            <div className='weixin-code-image'>
                                                <img src={qrCodeUrl} alt="QR Code" style={{borderRadius: '8px'}}/>
                                                <h6 className={'mt-2'}
                                                    style={{
                                                        color: '#B4BFC5',
                                                        textAlign: 'center',
                                                        fontSize: '16px'
                                                    }}><span
                                                    style={{marginRight: '10px'}}><img src={wechatIcon} width={34}
                                                                                       alt={''}/></span>微信扫码登录
                                                </h6>
                                            </div>

                                        )}
                                    </div>
                                    :
                                    <Form onSubmit={handleLogin}>
                                        <h6 style={{
                                            color: '#B3BFC4',
                                            textAlign: 'center',
                                        }}>未注册的手机号码将自动创建平台账号</h6>
                                        <Form.Group className={'mb-3 d-flex'}
                                                    style={{
                                                        background: '#2A2E39',
                                                        padding: '4px 16px',
                                                        borderRadius: '12px'
                                                    }}>
                                    <span className={'align-content-center'} style={{marginRight: '10px'}}>
                                        <img src={phoneIcon} width={'20px'} alt={''}/>
                                    </span>

                                            <Form.Control ref={phoneInputRef}
                                                          style={{
                                                              background: 'transparent',
                                                              border: 'none',
                                                              color: 'white'
                                                          }}
                                                          type="text"
                                                          name="phoneNumber" placeholder={'请输入手机号'} required
                                                          onChange={handlePhoneNumberChange}/>
                                        </Form.Group>


                                        <Form.Group className={'mb-3 d-flex'}
                                                    style={{
                                                        background: '#2A2E39',
                                                        padding: '4px 0px 4px 16px',
                                                        borderRadius: '12px'
                                                    }}>
                                    <span className={'align-content-center'} style={{marginRight: '10px'}}>
                                        <img src={codeIcon} width={'20px'} alt={''}/>
                                    </span>
                                            <Form.Control
                                                style={{background: 'transparent', border: 'none', color: 'white'}}
                                                type="text"
                                                name="verificationCode" required placeholder={'请输入验证码'}/>

                                            <button
                                                type={'button'}
                                                style={{
                                                    width: '120px',
                                                    color: '#02C8E3',
                                                    border: 'none',
                                                    background: 'none',
                                                    flexShrink: 0,
                                                    textAlign: 'center',
                                                    alignContent: 'center'
                                                }}
                                                disabled={isButtonDisabled}
                                                onClick={handleVerificationClick}>
                                                {isButtonDisabled ? `等待${countdown}秒` : '获取验证码'}
                                            </button>

                                        </Form.Group>


                                        <div className='login-bottom mb-2 mt-2'>
                                            <Button variant="primary" type="submit" style={{
                                                width: '100%',
                                                background: 'linear-gradient(90deg, #963BC8, #02C8E3)',
                                                border: 'none',
                                                height: '42px',
                                            }}>
                                                登录
                                            </Button>
                                        </div>
                                    </Form>
                            }
                            <div>
                                <p style={{color: '#B3BFC4', textAlign: 'center', fontSize: '16px'}}> 欢迎使用沸推AI ,
                                    您登录即同意
                                    <a href={'https://ft.motubizhi.com/h5/user'} target="_blank"
                                       style={{color: '#02C8E3', textDecoration: 'none'}}
                                       rel="noreferrer">《用户协议》</a> 和
                                    <a href={'https://ft.motubizhi.com/h5/privacy'} target="_blank"
                                       style={{color: '#02C8E3', textDecoration: 'none'}}
                                       rel="noreferrer">《隐私政策》</a>
                                </p>
                            </div>
                        </>
                    }

                </Modal.Body>
            </Modal>
        </>
    );
});

export default UserProfile;